// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import articleContents from "./articleContents";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();
articleContents();

function showOriginal(image) {
    if (image instanceof HTMLImageElement && image.classList.contains('dither') && !image.hidden) {
        image.hidden = true;
        console.warn('A dither image could not load; showing its original photograph.');
    }
}
document.addEventListener('error', event => showOriginal(event.target), true);
// Eager images can fail before this deferred bundle has executed.
document.querySelectorAll('img.dither').forEach(image => {
    if (image.complete && !image.naturalWidth) showOriginal(image);
});